module.exports = __webpack_public_path__ + "static/img/bg-cake.34aad73a.jpg";